import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { MenubarModule } from 'primeng/menubar';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { SplitButton } from 'primeng/splitbutton';
import { AuthService } from '../../../shared/providers/auth.service';
import { IUser } from '../../../shared/models/users/user.model';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RequestService } from '../../pages/service/request.service';
import { IRequest } from '../../../shared/models/users/request.model';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserProfileService } from '../../../shared/services/user-profile.service';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        StyleClassModule,
        AppConfigurator,
        MenubarModule,
        IconFieldModule,
        InputIconModule,
        InputIconModule,
        SplitButton,
        BadgeModule,
        OverlayPanelModule,
        ButtonModule
    ],
    template: `
    <div class="layout-topbar">
        <!-- LOGO -->
        <div class="layout-topbar-logo-container">
            <button
                class="layout-menu-button layout-topbar-action"
                (click)="layoutService.onMenuToggle()"
            >
                <i class="pi pi-bars"></i>
            </button>

            <a class="layout-topbar-logo" routerLink="/">
                <img width="32px"
                    src="assets/images/logo.png"
                    alt="logo"
                    class="topbar-logo-img"
                />
            </a>
             <span class="layout-topbar-title">Roya Workspace</span>
        </div>

        <!-- ACTIONS -->
        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <button
                    type="button"
                    class="layout-topbar-action"
                    (click)="toggleDarkMode()"
                >
                    <i
                        [ngClass]="{
                            'pi': true,
                            'pi-moon': layoutService.isDarkTheme(),
                            'pi-sun': !layoutService.isDarkTheme()
                        }"
                    ></i>
                </button>

                <div class="relative">
                    <button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button>
                    <app-configurator />
                </div>
            </div>

                <button class="layout-topbar-action" (click)="op.toggle($event)">
                    <i class="pi pi-bell p-overlay-badge" style="font-size: 1.2rem">
                        <p-badge *ngIf="(unreadRequests$ | async)?.length" [value]="((unreadRequests$ | async)?.length || 0).toString()" severity="danger"></p-badge>
                    </i>
                </button>

<p-overlayPanel #op [style]="{width: '400px', maxHeight: '500px'}">
  <ng-template pTemplate="content">
    <div class="notifications-container" *ngIf="(unreadRequests$ | async) as requests">
      
      <!-- حالة عدم وجود إشعارات -->
      <div *ngIf="requests.length === 0" class="no-notifications">
        No new notifications
      </div>

      <!-- الإشعارات الفعلية -->
      <div *ngFor="let req of requests" class="notification-item" (click)="viewRequest(req); op.hide()">
        <div class="notification-content">
          <div class="notification-header">
            <span class="notification-title">{{ req.title }}</span>
            <span class="notification-badge" [ngClass]="getBadgeClass(req.status)">{{ req.status }}</span>
          </div>
          <span class="notification-subtitle">
            <strong>{{ req.type }}</strong> - {{ getActionMessage(req) }}
          </span>
          <span class="notification-time">{{ getDate(req.createdAt) | date:'short' }}</span>
        </div>
        <button 
          pButton 
          icon="pi pi-check" 
          class="p-button-rounded p-button-text p-button-sm mark-read-btn"
          (click)="markAsRead(req); $event.stopPropagation()">
        </button>
      </div>

    </div>
  </ng-template>
</p-overlayPanel>



            <button
                class="layout-topbar-menu-button layout-topbar-action"
                pStyleClass="@next"
                enterFromClass="hidden"
                enterActiveClass="animate-scalein"
                leaveToClass="hidden"
                leaveActiveClass="animate-fadeout"
                [hideOnOutsideClick]="true"
            >
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
              

                    <a
                        [routerLink]="['/modules/users/view', currentUser$?.id]"
                        class="layout-topbar-action user-profile-link"
                    >
                        <img
                            [src]="currentUser$?.image || 'assets/images/user.png'"
                            alt="User Avatar"
                            class="user-avatar"
                        />
                        <span>Profile</span>
                    </a>

                    <p-splitButton
                        [label]="currentUser$?.firstName ?? currentUser$?.lastName ?? 'User'"
                        [model]="profileItems"
                    ></p-splitButton>
                </div>
            </div>
        </div>
    </div>
    `,
    styles: [`
        .layout-topbar {
            height: 56px;
            display: flex;
            align-items: center;
            padding: 0 1rem;
                        
        }

        .layout-topbar-logo-container {
            display: flex;
            align-items: center;
            height: 100%;
            gap: 8px;
        }

  

        .layout-topbar-logo {
            display: flex;
            align-items: center;
            height: 56px !important;
            overflow: hidden;
        }

        .topbar-logo-img {
            height: 10rem;
         
            max-height: 10rem;
      
            object-fit: contain;
        }

        .user-profile-link {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .user-avatar {
            width: 32px;
            height: 32px;
            min-width: 32px;
            border-radius: 50%;
            object-fit: cover;
        }
        ng-template{
            width: 400px;
            max-height: 500px;
            
            
        }
        .p-popover-content{
height: 100%; 
overflow: hidden;
        }
        .notifications-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  max-height: 500px;
  overflow-y: auto;
   
  height: 100%;         
  
}

.no-notifications {
  text-align: center;
  color: #555;
  padding: 1rem;
  font-size: 0.95rem;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.notification-item {
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 0.75rem 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 6px;
  transition: background-color 0.2s;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.notification-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0; /* مهم للـ text-overflow */
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
}

.notification-title {
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
}

.notification-badge {
    font-size: 0.7rem;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: bold;
    text-transform: uppercase;
}

.status-approved { background: #e8f5e9; color: #2e7d32; }
.status-rejected { background: #ffebee; color: #c62828; }
.status-pending { background: #fff3e0; color: #ef6c00; }
.status-signed { background: #e3f2fd; color: #1565c0; }
.status-default { background: #f5f5f5; color: #616161; }

.notification-subtitle {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 2px;
}

.notification-time {
  font-size: 0.75rem;
  color: #888;
}

.mark-read-btn {
  flex-shrink: 0;
  color: #4caf50; /* لون أيقونة التأكيد */
}

    `]
})
export class AppTopbar {
    items!: MenuItem[];

    profileItems: MenuItem[] = [
        {
            label: 'Logout',
            icon: 'pi pi-fw pi-sign-out',
            command: () => this.logout()
        }
    ];

    currentUser$!: IUser | null;
    unreadRequests$: Observable<IRequest<any>[]> = of([]);

    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private userProfileService: UserProfileService,
        private requestService: RequestService,
        private router: Router
    ) {
        this.userProfileService.currentUser$.subscribe((user) => {
            this.currentUser$ = user;
        });

        this.unreadRequests$ = this.userProfileService.currentUser$.pipe(
            switchMap(user => {
                if (user && user.id) {
                    return this.requestService.getUnreadRequests(user.role?.uid || '', user.id);
                }
                return of([]);
            })
        );
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update(state => ({
            ...state,
            darkTheme: !state.darkTheme
        }));
    }

    markAsRead(request: IRequest<any>) {
        if (this.currentUser$?.id && request.id) {
            this.requestService.markAsRead(request.id, this.currentUser$.id);
        }
    }

    viewRequest(request: IRequest<any>) {
        if (request.id && request.type) {
            this.markAsRead(request);
            const type = request.type.toLowerCase();
            this.router.navigate(['/modules/requests', type, 'view', request.id]);
        }
    }

    getActionMessage(request: IRequest<any>): string {
        const role = this.currentUser$?.role?.uid;
        if (role === 'HR' || role === 'ADMIN' || role === 'ACCOUNTANT') {
            if (request.status === 'PENDING') return 'Review required';
            if (request.status === 'SIGNED') return 'Pending final approval';
            return 'View request details';
        }

        // For Requester
        if (request.status === 'APPROVED') return 'Your request has been approved!';
        if (request.status === 'REJECTED') return 'Your request has been rejected.';
        return 'Check request status';
    }

    getBadgeClass(status: string): string {
        if (!status) return 'status-default';
        const s = status.toLowerCase();
        if (s.includes('approve')) return 'status-approved';
        if (s.includes('reject')) return 'status-rejected';
        if (s.includes('pending')) return 'status-pending';
        if (s.includes('signed')) return 'status-signed';
        return 'status-default';
    }

    getDate(date: any) {
        if (date && typeof date.toDate === 'function') {
            return date.toDate();
        }
        return date;
    }

    logout() {
        this.authService.logout();
    }
}
